export default {"src":"/_next/static/media/design-robust.00b855fa.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};